import { Script } from 'gatsby';
import React from 'react';

/**
 * A React functional component that embeds a script to set a global variable
 * `window.isSurveyDisplayed` to `false`. This can be used to control the display
 * state of a survey on the page.
 *
 * Opco specific scripts are comming from the CMS and are not included in this component.
 *
 * @component
 * @returns {JSX.Element} A script element that sets the `isSurveyDisplayed` variable.
 */
const SurveyScript: React.FC = () => {
  return (
    <Script id="init-is-survey-displayed">{`window.isSurveyDisplayed = false;`}</Script>
  );
};

export default SurveyScript;
